// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__BUoV6","header":"PatientBlock_header__8FG9B","label":"PatientBlock_label__teOie","option":"PatientBlock_option__1A5VE"};